module.exports = __webpack_public_path__ + "img/rudicon.d598c07b.png";